export enum TemplateType {
  Unordered = "unknown",
  FMX = "FMX",
  Pano = "Pano",
  /** This is used to indicate that there is no templating applied on an image. */
  Undefined = "",
}
